import React from 'react';
import { SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
import Recommended from '../../microComponents/Recommended';
import { Swiper } from './styles';

// Instalar o módulo Autoplay - sem isto, o autoplay não funciona
SwiperCore.use([Autoplay]);
type Props = React.PropsWithChildren<{
  contents: React.ReactNode[];
  recommendedBadge?: string;
  recommendedText?: string;
  zIndex?: number;
  style?: any;
  navigation?: boolean;
  pagination?: boolean;
  className?: string;
  borderRadius?: string;
  initialSlide?: number;
  paginationBottom?: string;
  autoplay?: boolean;
  autoplayDelay?: number;
  loop?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  onReachEnd?: () => void;
}>;
const SlideShow: React.FC<Props> = props => {
  const {
    contents,
    recommendedBadge,
    style,
    className,
    recommendedText,
    zIndex,
    navigation = true,
    pagination = false,
    borderRadius,
    paginationBottom,
    autoplay,
    autoplayDelay,
    loop,
    onClick,
    initialSlide,
    onReachEnd
  } = props;
  const swiperRef = React.useRef<any>();
  React.useEffect(() => {
    if (swiperRef?.current && initialSlide !== undefined) {
      swiperRef?.current.slideTo(initialSlide);
    }
  }, [initialSlide]);
  if (!contents || contents?.length == 0) return null;
  return <>
      {contents?.length > 1 ? <Swiper navigation={navigation} slidesPerView={1} pagination={pagination ? {
      clickable: true
    } : false} centeredSlides style={{
      ...style,
      borderRadius: borderRadius || '4px'
    }} className={className} initialSlide={initialSlide || 0} onSwiper={swiper => {
      if (swiperRef) {
        swiperRef.current = swiper;
        if (initialSlide !== undefined) swiper.slideTo(initialSlide);
      }
    }} onReachEnd={onReachEnd} $paginationBottom={paginationBottom} autoplay={autoplay ? {
      delay: autoplayDelay,
      disableOnInteraction: false,
      stopOnLastSlide: !loop
    } : false}>
          {contents?.map((content, idx) => <SwiperSlide onClick={onClick} key={idx}>
              {content}
            </SwiperSlide>)}
          {(recommendedBadge || recommendedText) && <Recommended recommendedBadge={recommendedBadge} recommendedText={recommendedText} badgePosition="bottom left" maxSize={90} margin={5} zIndex={zIndex ?? 3} />}
        </Swiper> : contents[0]}
    </>;
};
export default SlideShow;